export const inlineStyleTypes = {
  bold: 'BOLD',
  italic: 'ITALIC',
  underline: 'UNDERLINE',
};

export const blockTypes = {
  unstyled: 'unstyled',
  bulletedList: 'unordered-list-item',
  numberedList: 'ordered-list-item',
};

export const entityTypes = {
  link: 'LINK',
};
